var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4998 7.42822H2.13184C1.82134 7.42822 1.56934 7.17622 1.56934 6.86572C1.56934 6.55522 1.82134 6.30322 2.13184 6.30322H15.4998C15.8103 6.30322 16.0623 6.55522 16.0623 6.86572C16.0623 7.17622 15.8103 7.42822 15.4998 7.42822Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1509 10.3574C11.8404 10.3574 11.5854 10.1054 11.5854 9.79492C11.5854 9.48442 11.8337 9.23242 12.1442 9.23242H12.1509C12.4614 9.23242 12.7134 9.48442 12.7134 9.79492C12.7134 10.1054 12.4614 10.3574 12.1509 10.3574Z",
    fill: "#130F26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82282 10.3574C8.51232 10.3574 8.25732 10.1054 8.25732 9.79492C8.25732 9.48442 8.50557 9.23242 8.81607 9.23242H8.82282C9.13332 9.23242 9.38532 9.48442 9.38532 9.79492C9.38532 10.1054 9.13332 10.3574 8.82282 10.3574Z",
    fill: "#130F26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48764 10.3574C5.17714 10.3574 4.92139 10.1054 4.92139 9.79492C4.92139 9.48442 5.17039 9.23242 5.48089 9.23242H5.48764C5.79814 9.23242 6.05014 9.48442 6.05014 9.79492C6.05014 10.1054 5.79814 10.3574 5.48764 10.3574Z",
    fill: "#130F26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1509 13.2725C11.8404 13.2725 11.5854 13.0205 11.5854 12.71C11.5854 12.3995 11.8337 12.1475 12.1442 12.1475H12.1509C12.4614 12.1475 12.7134 12.3995 12.7134 12.71C12.7134 13.0205 12.4614 13.2725 12.1509 13.2725Z",
    fill: "#130F26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82282 13.2725C8.51232 13.2725 8.25732 13.0205 8.25732 12.71C8.25732 12.3995 8.50557 12.1475 8.81607 12.1475H8.82282C9.13332 12.1475 9.38532 12.3995 9.38532 12.71C9.38532 13.0205 9.13332 13.2725 8.82282 13.2725Z",
    fill: "#130F26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48764 13.2725C5.17714 13.2725 4.92139 13.0205 4.92139 12.71C4.92139 12.3995 5.17039 12.1475 5.48089 12.1475H5.48764C5.79814 12.1475 6.05014 12.3995 6.05014 12.71C6.05014 13.0205 5.79814 13.2725 5.48764 13.2725Z",
    fill: "#130F26"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8452 4.34325C11.5347 4.34325 11.2827 4.09125 11.2827 3.78075V1.3125C11.2827 1.002 11.5347 0.75 11.8452 0.75C12.1557 0.75 12.4077 1.002 12.4077 1.3125V3.78075C12.4077 4.09125 12.1557 4.34325 11.8452 4.34325Z",
    fill: "#130F26"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78638 4.34325C5.47588 4.34325 5.22388 4.09125 5.22388 3.78075V1.3125C5.22388 1.002 5.47588 0.75 5.78638 0.75C6.09688 0.75 6.34888 1.002 6.34888 1.3125V3.78075C6.34888 4.09125 6.09688 4.34325 5.78638 4.34325Z",
    fill: "#130F26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_641_24643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 16,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.93408H16.125V16.8748H1.5V1.93408Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_641_24643)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64075 3.05908C3.696 3.05908 2.625 4.09633 2.625 5.97958V12.7663C2.625 14.6908 3.696 15.7498 5.64075 15.7498H11.9843C13.929 15.7498 15 14.7103 15 12.8233V5.97958C15.003 5.05333 14.754 4.33333 14.2597 3.83833C13.7512 3.32833 12.9675 3.05908 11.991 3.05908H5.64075ZM11.9843 16.8748H5.64075C3.087 16.8748 1.5 15.3006 1.5 12.7663V5.97958C1.5 3.48358 3.087 1.93408 5.64075 1.93408H11.991C13.2727 1.93408 14.3325 2.31808 15.0563 3.04333C15.759 3.74908 16.1287 4.76383 16.125 5.98108V12.8233C16.125 15.3223 14.538 16.8748 11.9843 16.8748Z",
    fill: "#130F26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateCalendar);
export default __webpack_public_path__ + "static/media/dateCalendar.f4b5ac4f90283b4df7842be5adcc09d4.svg";
export { ForwardRef as ReactComponent };